export const queryHome = groq`*[ _type == "homePage"][0]`;
